module.exports = __webpack_public_path__ + "static/media/pain-overview@3x.7f7398be.png";